<template>
    <div class="container-fluid">
        <Breadcrumb title="Add SpamTrap Email" v-bind:button-show="false" v-show="!$route.params.id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit SpamTrap Email #' + $route.params.id" v-bind:button-show="false"
                    v-show="$route.params.id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-show="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">SpamTrap Email info</h4>
                        <SpamEmailForm @hidePreloader="hidePreloader"></SpamEmailForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SpamEmailForm from './forms/SpamEmailForm';

    export default {
        name: 'SpamEmail',
        components: {SpamEmailForm, Preloader, Breadcrumb},
        data() {
            return {
                loading: false
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            }
        }
    }
</script>

<style scoped>

</style>